import React from 'react';
import { Part } from './PartsList';
import Grid from '@material-ui/core/Grid';
import Info from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';
import format from '../../utils/formatter';
import { withNamespaces, WithNamespaces } from 'react-i18next';
import NoPartPreviewIcon from '@material-ui/icons/VisibilityOffOutlined';

export interface PartProps {
	part: Part
	fade: boolean;
	togglePart: (part: Part) => void;
	isIncluded: boolean,
	showDialog: (part: Part) => void;
	selectedFromSummary: boolean;
}

export const PartItem: React.FunctionComponent<PartProps & WithNamespaces> = (props) => {

	const { part, part: { CanBeRendered, Racing, PartId }, t, fade, togglePart, isIncluded, showDialog, selectedFromSummary: selected } = props;
	const faded = fade ? 'faded' : '';
	const partImageStyle: React.CSSProperties = {
		background: `url(${part.Images.Main})`,
		backgroundSize: 'contain',
		backgroundRepeat: 'no-repeat',
	};

	return (
		<div id={`part-${PartId}`} className={`part-wrapper ${faded} ${selected ? 'selected' : ''}`}>
			<Grid container direction="row" justify="space-between">
				<Grid item xs={11}>
					<h3 className={`part-headline`}>
						{part.Name.toUpperCase()}
						{Racing && <span
							className="racingComponent"
							title={t('configuration.parts.racing')}>
							{t('configuration.summary.ece')}
						</span>}
						{!CanBeRendered && <NoPartPreviewIcon fontSize="inherit" className="not-visualized-icon" titleAccess={t('configuration.parts.notVisualized')} />}
					</h3>
					<h4 className="ktm-dark-grey-color part-id">{part.PartId}</h4>
				</Grid>
				<Grid item xs={1} className="text-right">
					<IconButton className="show-part-detail-icon" onClick={showDialog.bind(null, part)}>
						<Info titleAccess={t('configuration.parts.viewDetail')} />
					</IconButton>
				</Grid>
			</Grid>
			<Grid container direction="row" justify="space-between" alignContent="center">
				<Grid item className="part-image-wrapper"><div className="full-height" style={partImageStyle}></div></Grid>
				<Grid item>
					<Grid container direction="column" justify="space-between">
						<Grid item><div className="part-price text-right">{format.currency(part.Price)}</div></Grid>
						<Grid item className="text-right">
							<button onClick={togglePart.bind(null, part)} className={isIncluded ? 'remove' : 'primary'} id={`add-part-${PartId}`}>
								{isIncluded ? t('configuration.parts.remove') : t('configuration.parts.add')}
							</button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</div>
	);
};

export default withNamespaces()(PartItem);
